import { useEffect, useState } from 'react';
import { Button, Input, InputNumber, Row, Col, Empty, Typography, Modal, Table, Image, Form, Drawer } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, VideoCameraTwoTone } from '@ant-design/icons';
import UploadImg from '../../../../components/Upload/UploadImg';
import { useSingleService } from './SingleServiceStore';
import { render } from 'katex';

const { Text } = Typography;

function Halls({ serviceId }) {
    const { halls, getHalls, addHall, updateHall, deleteHall, addTarif, deleteTarif } = useSingleService();
    const [modalOpen, setModalOpen] = useState(false);
    const [editRecord, setEditRecord] = useState(null);
    const [form] = Form.useForm();
    const [hallImage, setHallImage] = useState('');
    let [tarifDr, setTarifDr] = useState(false)
    let [activeHall, setActiveHall] = useState(null)
    let [tarifModal, setTarifModal] = useState(false)

    useEffect(() => {
        if (serviceId) getHalls(serviceId);
    }, [serviceId, getHalls]);

    useEffect(() => {
        if (!tarifDr) {
            setActiveHall(null);
        }
    }, [tarifDr]);

    const openAdd = () => {
        setEditRecord(null);
        setHallImage('');
        form.resetFields();
        setModalOpen(true);
    };

    const openEdit = (record) => {
        setEditRecord(record);
        setHallImage(record.image || '');
        form.setFieldsValue(record);
        setModalOpen(true);
    };

    const handleSubmit = (values) => {
        values.image = hallImage;
        values.services_id = serviceId;
        const promise = editRecord
            ? updateHall(editRecord.id, { ...values, id: editRecord.id })
            : addHall(values);
        promise?.then(() => {
            setModalOpen(false);
            form.resetFields();
            setHallImage('');
        });
    };

    const handleDelete = (record) => {
        Modal.confirm({
            title: "Zalni o'chirishni tasdiqlang",
            okText: "O'chirish", okType: 'danger', cancelText: 'Bekor qilish',
            onOk: () => deleteHall(record.id, serviceId),
        });
    };

    const columns = [
        {
            title: 'Rasm', dataIndex: 'image', key: 'image', width: 80,
            render: (img) => img ? <Image src={process.env.REACT_APP_URL + img} width={60} height={40} style={{ borderRadius: 6, objectFit: 'cover' }} /> : '—',
        },
        { title: 'Nomi', dataIndex: 'name', key: 'name' },
        { title: 'Maydoni (m²)', dataIndex: 'area', key: 'area' },
        { title: "O'rinlar", dataIndex: 'places', key: 'places' },
        { title: "Video", dataIndex: 'video', key: "video", render: ()=> <Button icon={<VideoCameraTwoTone />}></Button> },
        {
            title: '', key: 'actions', width: 80,
            render: (_, rec) => (
                <div style={{ display: 'flex', gap: 4 }}>
                    <Button type="primary" size="small" icon={<EditOutlined />} onClick={() => openEdit(rec)} />
                    <Button type="primary" danger size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(rec)} />
                </div>
            ),
        },
    ];

    return (
        <div style={{ padding: '16px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <Text strong style={{ fontSize: 16 }}>Zallar ({halls.length})</Text>
                <Button type="primary" icon={<PlusOutlined />} onClick={openAdd}>Zal qo'shish</Button>
            </div>
            <Modal open={tarifModal} onCancel={() => setTarifModal(false)} title="Tarif qo'shish" footer={null}>
                <h4 style={{ color: 'tomato' }}>Narxni ko'rsatayotganda bitta joy/kishi uchun ko'rsating.</h4>
                {activeHall && (
                    <Form layout='vertical' onFinish={(values) => {
                        addTarif(values, serviceId)
                        setTarifDr(false)
                        setTarifModal(false)
                    }}>
                        <Form.Item hidden name={'halls_id'} initialValue={activeHall.id}>
                            <Input />
                        </Form.Item>
                        <Form.Item name={"name"} label="Tarif nomi">
                            <Input />
                        </Form.Item>
                        <Form.Item name={"price"} label="Narxi">
                            <Input />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">Saqlash</Button>
                        </Form.Item>
                    </Form>
                )}
            </Modal>
            <Drawer size={'800px'} open={tarifDr} title="Tariflar" onClose={() => setTarifDr(false)}>
                {activeHall && (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <h4>{activeHall.name} Hall tariflari</h4>
                            <Button onClick={() => setTarifModal(true)} type='primary' size='medium'>Tarif qo'shish</Button>
                        </div>
                        <div>
                            <Table dataSource={activeHall.event_types} columns={[
                                { title: 'Turi', dataIndex: 'name', key: 'name' },
                                { title: 'Narxi', dataIndex: 'price', key: 'price' },
                                { title: "O'chirish", key: 'action', render: (v) => <Button onClick={() => deleteTarif(v.id, serviceId)} type='primary' icon={<DeleteOutlined />} size='medium' danger />, align: 'right' },
                            ]} />
                        </div>
                    </>
                )}
            </Drawer>
            <Modal
                title={editRecord ? "Zalni tahrirlash" : "Yangi zal qo'shish"}
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                footer={null}
                destroyOnClose
            >
                <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false}>
                    <Form.Item name="name" label="Zal nomi" rules={[{ required: true, message: 'Nomini kiriting' }]}>
                        <Input placeholder="Masalan: Asosiy zal" size="large" />
                    </Form.Item>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="area" label="Maydoni (m²)">
                                <InputNumber placeholder="150" size="large" style={{ width: '100%' }} min={0} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="places" label="O'rinlar soni">
                                <InputNumber placeholder="200" size="large" style={{ width: '100%' }} min={0} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label="Rasm">
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <UploadImg setImgurl={setHallImage} />
                            {hallImage && (
                                <Image src={process.env.REACT_APP_URL + hallImage} width={80} height={60} style={{ borderRadius: 8, objectFit: 'cover' }} />
                            )}
                        </div>
                    </Form.Item>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <Button onClick={() => setModalOpen(false)}>Bekor</Button>
                        <Button type="primary" htmlType="submit">Saqlash</Button>
                    </div>
                </Form>
            </Modal>

            <Table
                dataSource={halls}
                columns={columns}
                rowKey="id"
                size="small"
                pagination={false}
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Zallar yo'q" /> }}
            />
        </div>
    );
}

export default Halls;
